import React from 'react';
import '../App.css';
import {
    Row,
    Col
} from 'bootstrap-4-react';
import logo from '../logo.svg';
import phone from '../phone.svg'
import pin from '../pin.svg'
import mail from '../mail.svg'
import sk from '../skolkovo.jpg'
import msk from '../msk.png'

const styles = {
    regalies: {
        fontSize: '0.7em',
        lineHeight: '1.2em',
        color: 'grey',
        marginTop: '10px',
        marginBottom: '10px'
    }
}

function Footer() {
    
  return (
    <Row id="footer">
        <Col col="lg-4">
            <img src={logo} alt="logo" height="40"/>
            <p className="mt-3">&copy; ООО "Спрейпласт"</p>
        </Col>
        <Col col="lg-4">
            <div className='contactsRow'>
                <img src={phone} alt="phone" height="20"/>
                <p>8 800 550 0680</p>
            </div>
            <div className='contactsRow'>
                <img src={mail} alt="mail" height="20"/>
                <p>sale@sprayplast.ru</p>
            </div>
            <div className='contactsRow'>
                <img src={pin} alt="pin" height="20"/>
                <p>Москва, Проспект Андропова, 22с3</p>
            </div>
        </Col>
        <Col col="lg-4">
            <Row>
                <Col>
                    <img src={sk} height={'60px'} alt={'skolkovo'}/>
                    <div style={styles.regalies}>
                        Входим в Топ 60 инновационных компаний строительного рынка по версии Фонда Сколково в 2020 году
                    </div>
                </Col>
                <Col>
                    <img src={msk} height={'60px'} alt={'msk'}/>
                    <div style={styles.regalies}>
                        Отделочные материалы включены в территориальный справочник города Москвы как рекомендованные
                    </div>
                </Col>
            </Row>





        </Col>
    </Row>
  );
}

export default Footer;